// extracted by css-extract-rspack-plugin
export default {"Box":"EditIssues-module__Box__JB8C6","Octicon":"EditIssues-module__Octicon__eyfxj","Text":"EditIssues-module__Text__hMbmM","Text_1":"EditIssues-module__Text_1__pHLrN"};